import styled from 'styled-components';

const size = {
	mobileS: '320px',
	mobileM: '375px',
	mobileL: '425px',
	tablet: '768px',
	laptop: '1024px',
	laptopL: '1440px',
	desktop: '2560px'
};

export const device = {
	mobileS: `(min-width: ${size.mobileS})`,
	mobileM: `(min-width: ${size.mobileM})`,
	mobileL: `(min-width: ${size.mobileL})`,
	tablet: `(min-width: ${size.tablet})`,
	laptop: `(min-width: ${size.laptop})`,
	laptopL: `(min-width: ${size.laptopL})`,
	desktop: `(min-width: ${size.desktop})`,
	desktopL: `(min-width: ${size.desktop})`
};

export const Container = styled.div`
	max-width: 1450px;
	margin: 0 auto;
	padding: 20px;
`;

export const MenuIcon = styled.div`
	position: absolute;
	top: 10px;
	left: 10px;
	color: white;
	font-size: var(--fontL);
	cursor: pointer;
	height: 32px;
	width: 32px;
`;
